import { Box } from "@mui/material";
import React from "react";
import Domains from "./Domains";
import DateFilter from "./DateFilter";

function Filters({ selectedDomain, onDomainChange, dateFilter, onDateFilterChange }) {
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"space-between"}
      gap={2}>
      <Domains
        selectedDomain={selectedDomain}
        onDomainChange={onDomainChange}
      />
      <DateFilter dateFilter={dateFilter} onDateFilterChange={onDateFilterChange} />
    </Box>
  );
}

export default Filters;
